import AddIcon from "@mui/icons-material/Add";
import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import GlobalButton from "../../../components/button";
import DynamicTable from "../../../components/dynamicTable";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import { getAllDiscount, updateDiscount } from "../../../services/DiscountApiFn";
import { handleApiCall, handleOpenSnackBar } from "../../../utils/helper";
import AddEditDiscountDialog from "./AddEditDiscount";

const tableHeader = [
  "Created At",
  "Name",
  "Percentage",
  "No. of Months",
  "Contract Length",
  "Price",
  "CPS Terms",
  "Action",
];

const displayRows = [
  "lead_created_date",
  "code",
  "percentage",
  "discount_valid_months",
  "contract_lengths",
  "minimum_discount_price",
  "cps_terms",
  "actions",
];

const AdminDiscountPage = () => {
  const openAddEditDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allDiscount, setAllDiscount] = useState([]);

  const fetchAllDiscount = async () => {
    try {
      setIsLoading(true);
      const response = await getAllDiscount();
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllDiscount(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllDiscount();
  }, []);

  const handleUpateCpsTerms = async (row, e) => {
    handleApiCall(
      row._id,
      updateDiscount,
      { cpsTerms: e },
      setIsLoading,
      () => { },
      fetchAllDiscount
    );
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Box>
        <Stack
          direction={"row"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
          gap={2}
          mb={2}
        >
          <Typography
            variant="primaryText"
            component={"h1"}
            fontSize={{ xs: "1.5rem", md: "1.75rem" }}
          >
            List Of Discount
          </Typography>
          <GlobalButton
            variant="custom_gradient"
            title="Add Discount"
            startIcon={<AddIcon />}
            style={{
              width: { xs: "100%", sm: "auto" },
              borderRadius: "100px",
            }}
            handleClickBtn={() =>
              openAddEditDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllDiscount,
              })
            }
          />
        </Stack>

        <DynamicTable
          tableData={allDiscount || []}
          displayRows={displayRows}
          tableHeader={tableHeader}
          showEdit={true}
          handleChangeCpsTerms={handleUpateCpsTerms}
          handleEdit={(row) => {
            openAddEditDialog.current.openDialog({
              type: "edit",
              data: row,
              getData: fetchAllDiscount,
            });
          }}
        />
        {allDiscount?.length === 0 && isLoading === false && (
          <Typography variant="h5" fontWeight={600} textAlign={"center"}>
            No Data Found !
          </Typography>
        )}

        <AddEditDiscountDialog ref={openAddEditDialog} />
      </Box>
    </AppHeader>
  );
};

export default AdminDiscountPage;
